<template>
  <div v-if="(jwtAccessValid() && userProfile.checked && isReciever) || isAdmin" class="container pb-3"
    :class="{ 'pt-1': list }" style="max-width: 400px">
    <h1 class="text-center" v-if="!list">АКТ ПРИЕМКИ</h1>
    <div v-if="!loading" class="card lh-1">
      <div class="card-body">
        <div class="row row-cols-2">
          <div class="col text-muted">Дата</div>
          <div class="col text-muted">Номер</div>
          <div class="col">
            <v-date-picker :disabled="list || doc.cancel" v-model="doc.date" mode="dateTime" is24hr>
              <template v-slot="{ inputValue, inputEvents }">
                <input class="
                    px-0
                    fs-5
                    border
                    rounded
                    focus:outline-none focus:border-blue-300
                  " :value="inputValue" v-on="inputEvents" :disabled="list || doc.cancel"
                  style="width: 100%; padding-top: 2px; padding-bottom: 2px" />
              </template>
            </v-date-picker>
          </div>
          <div class="col">
            <input v-if="!list" class="form-control px-0 py-0 fs-5" :value="`${doc.prefix}-${doc.number}`"
              :disabled="true" type="text" />
            <span v-if="list" class="fs-3">{{
                `${doc.prefix}-${doc.number}`
            }}</span>
          </div>
        </div>

        <div v-if="!list && isAdmin" class="row row-cols-2 pt-2">
          <div class="col px-0">
            <input type="radio" :value="true" v-model="doc.fixPrice" :disabled="list || doc.cancel" class="btn-check"
              :name="`fix-price-${doc._id}`" :id="`fix-price-true-${doc._id}`" autocomplete="off" @change="
                () => {
                  clearDeliverer();
                  initFixPrice();
                }
              " />
            <label class="btn btn-outline-warning berry fs-5 text-dark"
              :for="`fix-price-true-${doc._id}`">ФиксПрайс</label>
          </div>

          <div class="col px-0">
            <input type="radio" :value="false" v-model="doc.fixPrice" :disabled="list || doc.cancel" class="btn-check"
              :name="`fix-price-${doc._id}`" :id="`fix-price-false-${doc._id}`" autocomplete="off" />
            <label class="btn btn-outline-warning berry fs-5 text-dark" :for="`fix-price-false-${doc._id}`">Расчетная
              цена</label>
          </div>
        </div>

        <div v-if="list || isWholesaler" class="row row-cols-1 pt-2">
          <div class="col text-center">
            <span v-if="doc.fixPrice" class="fs-1">ФиксПрайс</span>
          </div>
        </div>

        <div v-if="doc.fixPrice">
          <div class="row row-cols-1 pt-2 text-center">
            <div class="col text-muted">
              БОНУС оптовика за ФиксПрайс, руб/кг
            </div>
            <div class="col pt-1">
              <input v-if="!list" class="form-control px-0 input-price summ text-center" v-model="doc.fixPriceBonus"
                type="number" @input="calculateSum()" :disabled="list || doc.cancel || !isAdmin" />
              <span v-if="list" class="fs-4">{{ doc.fixPriceBonus }}</span>
            </div>
          </div>
          <div class="row row-cols-1 pt-2">
            <div class="col text-muted"><small>Оптовик</small></div>
            <div class="col">
              <Multiselect v-model="doc.company" :options="usersWholesaler" :loading="false" :internal-search="false"
                valueProp="_id" trackBy="fullname" label="fullname" :filterResults="true" :minChars="2"
                :resolveOnLoad="true" :searchable="true" class="deliverer" style="min-height: 3rem"
                noOptionsText="Не найден" required :disabled="list || doc.cancel || !isAdmin">
              </Multiselect>
            </div>
          </div>
        </div>

        <div v-if="berries.length > 0 && !list" class="row row-cols-2 pt-2">
          <div v-for="berry in berries" :key="berry._id" class="col px-0">
            <input type="radio" class="btn-check" :name="`berries-${doc._id}`" :disabled="list || doc.cancel"
              :value="berry._id" v-model="doc.tableUnit[0].berry" :id="`berry-${berry._id}`" autocomplete="off"
              @change="getCurrentPrice" />
            <label class="btn btn-outline-primary berry fs-5" :for="`berry-${berry._id}`">{{ berry.label }}</label>
          </div>
        </div>

        <div v-if="list" class="row row-cols-1 pt-2">
          <div class="col text-center">
            <span class="fs-1"><strong>{{ berries[0].label }}</strong></span>
          </div>
        </div>

        <div class="row row-cols-2 pt-2 text-center">
          <div class="col text-muted">Вес, кг</div>
          <div class="col text-muted">Цена, руб/кг</div>
          <div class="col pt-1">
            <input v-if="!list" class="form-control px-0 input-price summ text-center" v-model="doc.tableUnit[0].weight"
              type="number" @input="calculateSum()" :disabled="list || doc.cancel" />
            <span v-if="list" class="fs-4">{{ doc.tableUnit[0].weight }}</span>
          </div>
          <div class="col pt-1">
            <input v-if="!list" class="form-control px-0 input-price summ text-center" v-model="doc.tableUnit[0].price"
              type="number" @input="calculateSum()" :disabled="!doc.fixPrice || doc.cancel" />
            <span v-if="list" class="fs-4">{{ doc.tableUnit[0].price }}</span>
          </div>
        </div>
        <div class="row row-cols-2 pt-2 text-center">
          <div class="col text-muted">Сумма, руб</div>
          <div class="col text-muted">Сумма бонусов приемщика, руб</div>
          <div class="col pt-1">
            <input v-if="!list" class="form-control text-center px-0 input-price summ" :value="doc.sum.toFixed(2)" type="number"
              :disabled="true" />
            <span v-if="list" class="fs-4 lh-1"><strong>{{ doc.sum.toFixed(2) }}</strong></span>
          </div>
          <div class="col pt-1">
            <input v-if="!list" class="form-control text-center px-0 input-price summ" :value="doc.receiverBonusTotal" type="number"
              :disabled="true" />
            <span v-if="list" class="fs-4 lh-1"><strong>{{ doc.receiverBonusTotal.toFixed(2) }}</strong></span>
          </div>
        </div>

        <div v-if="!list && false" class="row row-cols-1 mt-2 px-0 text-center">
          <div class="col text-muted"><small>СУММА К ВЫПЛАТЕ С УЧЕТОМ БОНУСОВ СДАТЧИКА</small></div>
          <div class="col px-1">
            <input class="form-control p-1 text-center input-price summ" :value="doc.tableUnit[0].weight * doc.delivererBonus + doc.sum" type="number"
              disabled />
          </div>
        </div>

        <div v-if="!list" class="row row-cols-2 pt-2">
          <div class="col px-0">
            <input type="radio" :value="true" v-model="doc.cash" :disabled="list || doc.cancel" class="btn-check"
              :name="`cash-${doc._id}`" :id="`cash-true-${doc._id}`" autocomplete="off" @change="clearDeliverer()" />
            <label class="btn btn-outline-primary berry fs-5" :for="`cash-true-${doc._id}`">Наличные</label>
          </div>
          <div class="col px-0">
            <input type="radio" :value="false" v-model="doc.cash" :disabled="list || doc.cancel" class="btn-check"
              :name="`cash-${doc._id}`" :id="`cash-false-${doc._id}`" autocomplete="off" />
            <label class="btn btn-outline-primary berry fs-5" :for="`cash-false-${doc._id}`">На счет</label>
          </div>
        </div>

        

        <div v-if="list" class="row row-cols-1 pt-2">
          <div class="col text-center">
            <span v-if="doc.cash" class="fs-1">Наличные</span>
            <span v-if="!doc.cash" class="fs-1">На счет</span>
          </div>
        </div>

        <div v-if="!doc.cash" class="row row-cols-1 pt-2">
          <div class="col text-muted">Сдатчик (введите телефон для поиска)</div>
          <div class="col px-0">
            <div class="input-group">
              <span class="input-group-text p-1 fs-4" id="basic-addon1">+7</span>
              <input id="phone" class="form-control p-1 fs-4" v-model="phoneSearch" type="tel" pattern="[0-9]{10}"
                required placeholder="1234567890" @input="fetchDeliverer" :disabled="list || doc.cancel" />
              <input class="form-control p-1 fs-4" type="text" disabled v-model="doc.delivererFullname" />
            </div>
          </div>
        </div>

        

        <div v-if="!doc.cash && !list" class="row row-cols-2 mt-2 px-0">
          <div class="col text-muted"><small>БОНУС</small></div>
          <div class="col text-muted"><small>БОНУС ВСЕГО</small></div>
          <div class="col px-1">
            <input class="form-control p-1 fs-4" v-model="doc.delivererBonus" type="number" disabled />
          </div>
          <div class="col px-1">
            <input class="form-control p-1 fs-4" :value="doc.tableUnit[0].weight * doc.delivererBonus" type="number"
              disabled />
          </div>
        </div>

        

        <div class="row row-cols-1 mt-2 px-0">
          <div class="col text-muted"><small>Комментарий</small></div>
          <div class="col px-1">
            <input class="form-control p-1 fs-4" v-model="doc.comment" type="text" />
          </div>
        </div>

        <div v-if="!list" class="row row-cols-1 pt-1">
          <div class="col px-0">
            <button id="save-doc" type="button" class="btn btn-success btn-lg w-100" @click="saveDoc"
              :disabled="doc.cancel">
              ЗАПИСАТЬ
              <div v-if="loadingSave" class="spinner-border" role="status">
                <span class="sr-only"></span>
              </div>
            </button>
            <button v-if="false" id="save-doc" type="button" class="btn btn-info btn-lg w-100 mt-2" @click="payOff"
              :disabled="doc.cancel">
              ВЫПЛАТИТЬ
              <div v-if="loadingPayOff" class="spinner-border" role="status">
                <span class="sr-only"></span>
              </div>
            </button>
            <button id="save-doc" type="button" class="btn btn-primary btn-lg w-100 mt-2" @click="addDoc">
              НОВЫЙ
              <div v-if="loadingPayOff" class="spinner-border" role="status">
                <span class="sr-only"></span>
              </div>
            </button>
            <button v-if="doc.cancel || isAdmin" id="save-doc" type="button" class="btn btn-danger btn-lg w-100 mt-2"
              @click="cancelDoc()" :disabled="doc.cancel">
              <span v-if="doc.cancel"> ОТМЕНЕН </span>
              <span v-if="!doc.cancel"> ОТМЕНИТЬ </span>

              <div v-if="loadingPayOff" class="spinner-border" role="status">
                <span class="sr-only"></span>
              </div>
            </button>
            <router-link v-if="!list" class="btn btn-lg btn-secondary w-100 text-center mt-2" type="button" tag="button"
              :to="{ name: 'acceptances' }">
              НАЗАД
            </router-link>
          </div>
        </div>

        <div v-if="!list" id="modal-msg" class="modal justify-content-center" tabindex="-1">
          <div class="vertical-alignment-helper">
            <div class="modal-dialog vertical-align-center">
              <div class="modal-content">
                <div class="modal-body berry">
                  <ul class="list-group">
                    <li v-for="(msg, index) in modalMessages" :key="index" class="list-group-item">
                      {{ msg }}
                    </li>
                  </ul>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Закрыть
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted, onBeforeMount, inject } from "vue"
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import useCommonMixin from '@/components/commonMixin.js'
import Multiselect from '@vueform/multiselect'
import * as bootstrap from 'bootstrap'


export default {
  name: "Acceptance",

  components: {
    Multiselect,
  },

  props: {
    id: { default: 'new' },
    list: { default: false },
  },

  setup(props) {
    const store = useStore()
    const router = useRouter()
    useCommonMixin()
    const { jwtAccessValid, userProfile, isReciever, isAdmin, isWholesaler, asyncForEach } = useCommonMixin()
    const doc = ref({})
    const companyProfile = ref({})
    const loading = ref(true)
    const loadingSave = ref(false)
    const loadingPayOff = ref(false)
    const deliverer = ref([])
    const modalMessages = ref([])
    const phoneSearch = ref('')
    const warningBus = inject("warningBus"); // Inject `emitter`
    const users = ref([]);
    const roles = ref([]);

    const addDoc = async () => {
      await router.push({ name: 'acceptance', params: { id: 'new' } })
      await init()
    }

    const init = async () => {
      //await store.dispatch('FETCHuserProfile', {userId: null, phone: null})
      //store.dispatch('FETCHberry')
      phoneSearch.value = ''
      if (props.id == 'new') {
        doc.value = {
          _id: null,
          date: new Date(),
          number: '',
          prefix: '',
          company: userProfile.value['_id'],
          deliverer: null,
          delivererBonus: 0,
          totalBonus: 0,
          sum: 0,
          total: 0,
          cash: true,
          tableUnit: [
            {
              berry: null,
              weight: '',
              price: '',
            }
          ],
          fixPrice: false,
          fixPriceBonus: '',
        }
      } else {
        let response = await store.dispatch('FETCHacceptance', props.id)
        if (response.status) doc.value = response.data
        doc.value.date = new Date(doc.value.date)
        doc.value.receiverBonusTotal = doc.value.receiverBonusTotal.toFixed(2)
        
      }
      // companyProfile.value = await store.dispatch('FETCHuserProfile', {userId: doc.value.company, phone: null})
      // deliverer.value = [await store.dispatch('FETCHuserProfile', {userId: doc.value.deliverer, phone: null})]
      loading.value = false
      fetchDeliverer()

      if (doc.value.fixPrice) {
        initFixPrice()
      }
    }

    const calculateSum = () => {
      console.log('calculate');
      doc.value.totalBonus = doc.value.delivererBonus * doc.value.tableUnit[0].weight
      doc.value.sum = doc.value.tableUnit[0].weight * doc.value.tableUnit[0].price
      doc.value.total = doc.value.sum + doc.value.totalBonus
      // if (!doc.value._id) {
      //   doc.value.receiverBonusTotal = userProfile.value.bonus * doc.value.tableUnit[0].weight
      // }
    }

    const fetchDeliverer = async () => {
      let query = phoneSearch.value
      console.log(query);
      let user = [{ _id: '', fullname: '', bonus: 0 }]
      let userId = query ? null : doc.value.deliverer
      let phone = query ? query : null
      if (query.length == 0 || query.length >= 10) {
        let response = await store.dispatch('FETCHuserProfile', { userId: userId, phone: phone })
        console.log(response);
        user = response ? response : { _id: null, fullname: '', phone: '', bonus: 0 }
        user.fullname = user.passport ? `${user.passport.firstName} ${user.passport.middleName} ${user.passport.lastName.slice(0, 1)}.` : ''
      }
      doc.value.deliverer = user._id
      doc.value.delivererFullname = user.fullname
      doc.value.delivererBonus = user.bonus != 'undefined' ? user.bonus : 0
      if (phoneSearch.value.length == 0) {
        phoneSearch.value = user.phone.slice(2, 12)
      }
      getCurrentPrice()
    }


    const saveDoc = async () => {
      loadingSave.value = true
      let myModal = new bootstrap.Modal(document.getElementById("modal-msg"), {});
      modalMessages.value = []
      if (!doc.value.tableUnit[0].berry) modalMessages.value.push('Выберите ягоду')
      if (!doc.value.tableUnit[0].weight) modalMessages.value.push('Заполните вес')
      if (!doc.value.tableUnit[0].price) modalMessages.value.push('Заполните цену')
      if (!doc.value.cash && !doc.value.deliverer) modalMessages.value.push('Выберите сдатчика')

      if (modalMessages.value.length <= 0) {
        let response = await store.dispatch('POSTacceptance', doc.value)
        if (response.status) {
          modalMessages.value = ['Акт приемки сохранен']
          doc.value = response.data
          doc.value.date = new Date(doc.value.date)
          await fetchDeliverer()
          addDoc()
          // router.push({ name: 'acceptance', params: { id: response.data._id } })
        } else {
          modalMessages.value = [response.data.data.message]
        }
      }
      myModal.show()
      loadingSave.value = false
    }

    const cancelDoc = async () => {
      loadingSave.value = true
      let myModal = new bootstrap.Modal(document.getElementById("modal-msg"), {});
      modalMessages.value = []

      let response = await store.dispatch('CANCELacceptance', doc.value)
      if (response.status) {
        modalMessages.value = ['Акт приемки отменен']
        doc.value = response.data
        doc.value.date = new Date(doc.value.date)
        router.push({ name: 'acceptance', params: { id: response.data._id } })
      } else {
        modalMessages.value = [response.data.data.message]
      }
      myModal.show()
      loadingSave.value = false
    }

    const payOff = async () => {
      loadingPayOff.value = true
      let response = await store.dispatch('POSTpayoffOrder', { acceptance: doc.value._id })
      let myModal = new bootstrap.Modal(document.getElementById("modal-msg"), {});
      modalMessages.value = []
      if (response.status) {
        modalMessages.value.push('Выплата отправлена')
      } else {
        modalMessages.value.push(response.data.message)
      }
      myModal.show()
      loadingPayOff.value = false
    }

    const berries = computed(() => {
      let berry
      if (props.list) {
        let berryIndex = store.getters.berry.findIndex(item => item._id == doc.value.tableUnit[0].berry)
        berry = berryIndex >= 0 ? [store.getters.berry[berryIndex]] : [{ label: '', _id: '' }]
      } else {
        berry = store.getters.berry
      }
      return berry
    })

    const getCurrentPrice = async () => {
      if (newDoc.value) {
        doc.value.tableUnit[0].price = 0
        let deliverer = doc.value.deliverer ? doc.value.deliverer : null
        console.log('deliverer', deliverer);
        let response = await store.dispatch('FETCHcurrentPrice', { berryId: doc.value.tableUnit[0].berry, delivererId: deliverer })
        if (response.status) {
          doc.value.tableUnit[0].price = response.data.price
        } else {
          doc.value.tableUnit[0].price = 0
          warningBus.emit("show", ["Не удалось получить цену. Повторите позже.", response.data]);
        }
        calculateSum()
      }
    }

    const newDoc = computed(() => {
      return doc.value._id ? false : true
    })

    const clearDeliverer = () => {
      phoneSearch.value = ""
      doc.value.deliverer = null
      doc.value.delivererFullname = ''
      doc.value.delivererBonus = 0
      getCurrentPrice()
    }

    const initFixPrice = async () => {
      let response = await store.dispatch("FETCHuser", "receiver");
      users.value = response.status ? response.data : [];
      asyncForEach(users.value, async (user) => {
        user.phone = user.phone ? user.phone.slice(2, 12) : '';
        user.fullname = user.receiver.fullname;
      });

      let responseRoles = await store.dispatch("FETCHroles");
      roles.value = responseRoles.status
        ? responseRoles.data.filter((role) => role.type != "deliverer")
        : [];
    }

    const usersWholesaler = computed(() => {
      let result = []
      let wholesalerRole = roles.value.find(
        (item) => item.name == "wholesaler"
      );
      let receiverRole = roles.value.find(
        (item) => item.name == "receiver"
      );

      if (wholesalerRole && receiverRole) {
        result = users.value.filter(
          (item) => item.role == wholesalerRole._id || item.role == receiverRole._id
        );
      }

      console.log("result", result);
      return result;
    });



    onBeforeMount(init)

    return {
      jwtAccessValid,
      isReciever,
      doc,
      companyProfile,
      fetchDeliverer,
      berries,
      saveDoc,
      loading,
      deliverer,
      modalMessages,
      userProfile,
      payOff,
      phoneSearch,
      isAdmin,
      loadingSave,
      loadingPayOff,
      getCurrentPrice,
      newDoc,
      clearDeliverer,
      calculateSum,
      addDoc,
      initFixPrice,
      usersWholesaler,
      cancelDoc,
      isWholesaler,

    };
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css">
</style>

<style>
</style>

